import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  align-items: center;
  flex-direction: raw;
  max-width: 1000px;
  margin: 0 auto;
  padding: 0 15px;
`;
